var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class TraitPriority {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get trait() {
        return this.parent;
    }
    get aspect() {
        return this.trait.aspect;
    }
    get autoPriority() {
        if (this.aspect && this.aspect.traits && this.aspect.traits.includes(this.trait)) {
            return this.aspect.traits.length - this.aspect.traits.indexOf(this.trait) + 1000;
        }
    }
    get priority() {
        if (this.trait.priority)
            return this.trait.priority;
        if (this.autoPriority)
            return this.autoPriority;
        return -1;
    }
}
__decorate([
    computed
], TraitPriority.prototype, "autoPriority", null);
__decorate([
    computed
], TraitPriority.prototype, "priority", null);
